export function getErrorMessage(error: any): string {
  // Nếu error từ Axios và có response từ server
  if (error?.response) {
    if (!error?.response?.data?.error?.message) {
      return 'Lỗi hệ thống. Vui lòng thử lại sau.';
    }

    const code = `(CODE: ${error?.response?.data?.error?.code})`;

    return `${error?.response?.data?.error?.message} ${code}` || 'Lỗi không xác định từ máy chủ';
  }

  // Nếu lỗi là do request bị hủy hoặc lỗi khác từ network
  if (error?.request) {
    return 'Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng.';
  }

  // Các lỗi khác (do code phía client)
  return error?.message || 'Đã có lỗi xảy ra';
}
